import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import ImportQuiz from './pages/ImportQuiz';
import QuizRunner from './pages/QuizRunner';
import QuizResults from './pages/QuizResults';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/import" element={<ImportQuiz />} />
        <Route path="/quiz/:id" element={<QuizRunner />} />
        <Route path="/results" element={<QuizResults />} />
      </Routes>
    </Router>
  );
}

export default App;